import React, { Component } from "react";

class Leaderboard extends Component {
  state = { data: [] };
  componentDidMount() {
    fetch(
      "https://rl8b1iyh90.execute-api.us-west-2.amazonaws.com/production/leaderboard?limit=10'",
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      }
    )
      .then(response => response.json())
      .then(data => this.setState({ data }));
  }
  render() {
    return (
      <div>
        {this.state && (
          <div>
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td>#</td>
                  <td>contender</td>
                  <td>wins</td>
                  <td>losses</td>
                  <td>score</td>
                </tr>
              </thead>
              <tbody>
                {this.state.data.length > 0 &&
                  this.state.data.map((ele, i) => (
                    <tr key={ele.name}>
                      <td>{i + 1}</td>
                      <td style={{ width: 50 }}>
                        <div
                          style={{ width: 50, height: 50 }}
                          dangerouslySetInnerHTML={{
                            __html:
                              ele.name !== "steve"
                                ? atob(ele.svg)
                                : atob(ele.svg)
                                    .replace(/width/i, "")
                                    .replace(/height/i, "")
                          }}
                        />
                      </td>
                      <td>{ele.wins}</td>
                      <td>{ele.losses}</td>
                      <td>{ele.score}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/Leaderboard.js